<template>
  <div class="app-wrapper">
    <div class="main-container">
      <div
        class="
          fixed-header sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur
          supports-[backdrop-filter]:bg-background/60
        "
      >
        <Navbar v-if="finishedTenant && finishedEntityTypes" />
      </div>
      <router-view
        class="sidebar-container"
        name="sidebar"
      />
      <AppMain v-if="finishedTenant && finishedEntityTypes" />
    </div>
    <AiPanel v-if="hasAiModule" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import AiPanel from '@/components/AiPanel/index.vue'
import { useUserStore } from '@/stores/user'

const { hasAiModule } = useUserStore()

import AppMain from './components/AppMain.vue'
import Navbar from './components/Navbar/index.vue'
// State
const finishedTenant = ref(false)
const finishedEntityTypes = ref(false)

// Methods

const getTenant = () => {
  return useUserStore().getTenantInfo()
}

const getEntityTypes = () => {
  return useUserStore().getEntityTypes()
}

// Lifecycle
onMounted(async () => {
  // P0.2: Parallelize independent boot fetches to reduce TTFI by 400-900ms.
  // See docs/plans/prod1-performance-analysis.md (P0.2).
  // allSettled is used so one slow/failing endpoint does not block the other's flag
  // flipping, matching prior per-call granularity.
  const [tenantResult, entityTypesResult] = await Promise.allSettled([
    getTenant(),
    getEntityTypes(),
  ])

  finishedTenant.value = true
  finishedEntityTypes.value = true

  if (tenantResult.status === 'rejected') {
    console.error('[layout] getTenantInfo failed:', tenantResult.reason)
  }
  if (entityTypesResult.status === 'rejected') {
    console.error('[layout] getEntityTypes failed:', entityTypesResult.reason)
  }
})
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.main-container {
  min-height: 100%;
  transition: margin-left 0.28s;
  position: relative;
}

.sidebar-container {
  position: fixed;
  left: 0;
  top: var(--nav-height);
  width: var(--little-sidebar-width);
  bottom: 0;
  z-index: 1;
  border-right: 1px solid #e3e3e3;
}

// .fixed-header {
//   position: fixed;
//   top: 0;
//   right: 0;
//   z-index: 2001; // because of loading of KPIs
//   width: calc(100%);
//   transition: width 0.28s;
// }

// .hideSidebar {
//   .fixed-header {
//     width: calc(100%);
//   }
// }
</style>
